export enum InsightMetricDisplay {
	TRANSITION = 'transition',
	DELTA = 'delta',
	RATIO = 'ratio',
	VALUE = 'value',
}
